import React, { useEffect, useState } from "react";
import {
    Button,
    Container,
    Content,
    Description,
    FooterMenu,
    Divider,
    Hero,
    TendbeSVG,
    TendbeWorld,
    Title,
    StyledGrid,
    MessageWrapper,
    SubMessage,
    SubMessageTop,
    AnimatedMessage,
    SubMessageBottom,
    SubMessageParticle,
} from "@Styled/Pages/Login";
import { Header } from "@Components";
import { SignupForm } from "@Components/Signup";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Grid, Snackbar } from "@mui/material";
import { SnackbarCloseReason } from "@mui/material/Snackbar";
import MainIlustration from "@Static/images/tendbe-world-c.svg";
import { useNavigate, useLocation } from "react-router-dom";
import Alert from "@mui/material/Alert";
import { useTranslation } from "react-i18next";

interface LoginLocationState {
    activation_failed?: boolean;
    from?: {
        state?: {
            activation_failed?: boolean;
        };
    };
}

const Login: React.FC<any> = () => {
    const { t } = useTranslation();
    const [open, setOpen] = React.useState(false);
    const [activationError, setActivationError] = useState<boolean>(false);
    const location = useLocation();
    const locationState = location.state as LoginLocationState | undefined;
    const navigate = useNavigate();
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCallback = (childData: boolean) => {
        if (childData) {
            handleClose();
        }
    };

    const handleCloseAlert = (
        event?: Event | React.SyntheticEvent<any, Event>,
        reason?: SnackbarCloseReason
    ) => {
        if (reason === "clickaway") {
            return;
        }
        setActivationError(false);
        navigate("/", { replace: true });
    };

    useEffect(() => {
        if (
            locationState?.activation_failed ||
            locationState?.from?.state?.activation_failed
        ) {
            setActivationError(true);
        }
    }, [locationState]);

    return (
        <>
            <StyledGrid container>
                <Grid item xs={12}>
                    <Hero>
                        <Divider />
                        <Header showNav={true} showJoinButton={false} />
                        <Container>
                            <Content>
                                <Title>
                                    <span>{t("login.title")}</span>
                                    <SubMessage>
                                        <MessageWrapper>
                                            <AnimatedMessage>
                                                <div className="word1">
                                                    &nbsp;{t("login.word1")}
                                                </div>
                                                <div className="word2">
                                                    &nbsp;{t("login.word2")}
                                                </div>
                                                <div className="word3">
                                                    {t("login.word3")}
                                                </div>
                                            </AnimatedMessage>
                                        </MessageWrapper>
                                        <SubMessageTop>
                                            <SubMessageParticle>
                                                {t("login.submessageparticle")}
                                            </SubMessageParticle>
                                            {t("login.anonymus")}{" "}
                                        </SubMessageTop>
                                        <SubMessageBottom>
                                            {" "}
                                            {t("login.data_collection")}
                                        </SubMessageBottom>
                                    </SubMessage>
                                </Title>
                                <Description>
                                    {t("login.description")}
                                    <br></br>
                                </Description>
                                <br></br>
                                <Button onClick={handleOpen}>
                                    {" "}
                                    {t("login.start_now")}
                                </Button>
                                <div>
                                    <Dialog
                                        open={open}
                                        onClose={handleClose}
                                        aria-labelledby="form-dialog-title"
                                    >
                                        <DialogContent>
                                            <SignupForm
                                                parentCallback={handleCallback}
                                            />
                                        </DialogContent>
                                    </Dialog>
                                </div>
                            </Content>
                            <TendbeWorld>
                                <TendbeSVG src={MainIlustration} />
                            </TendbeWorld>
                        </Container>
                        <FooterMenu>
                            <ul className="ft-menu-list">
                                <li className="ft-menu-item">
                                    <small>
                                        <a
                                            href="https://tendbe.com/"
                                            target="_blank"
                                            rel=" noopener noreferrer"
                                        >
                                            {t("login.terms")}
                                        </a>
                                    </small>
                                </li>
                                <li className="ft-menu-item">
                                    <small>
                                        <a
                                            href="https://tendbe.com/privacy"
                                            target="_blank"
                                            rel=" noopener noreferrer"
                                        >
                                            {t("login.privacy")}
                                        </a>
                                    </small>
                                </li>
                                <li className="ft-menu-item">
                                    <small>
                                        <a
                                            href="https://tendbe.com/"
                                            target="_blank"
                                            rel=" noopener noreferrer"
                                        >
                                            {t("login.faq")}
                                        </a>
                                    </small>
                                </li>
                                <li>
                                    <small>Copyright © 2025 Tendbe OÜ</small>
                                </li>
                            </ul>
                        </FooterMenu>
                    </Hero>
                </Grid>
            </StyledGrid>
            {
                <Snackbar
                    open={activationError}
                    autoHideDuration={3000}
                    onClose={handleCloseAlert}
                >
                    <Alert severity="error">
                        Error while verifying account.
                    </Alert>
                </Snackbar>
            }
        </>
    );
};

export default Login;
